module.exports = __webpack_public_path__ + "static/media/portfolio-bg.68ce5bcb.jpg";